var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('m-autocomplete',_vm._b({attrs:{"items":_vm.items,"search-input":_vm.search,"sentry-tag":"m-time-zone-picker"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'m-autocomplete',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }